//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { axiosGet } from '../../../../axios/axios.js'
import ItemsSearchField from '../../../../components/Field/ItemsSearchField.vue'
import { createFieldConfig, Store } from '../../../../components/QSelectUtils'
// import { getStoredSelectedDepartmentId, setStoredSelectedDepartmentId } from './StockControl.js'

const SELECTED_DEPARTMENT_ID_PROPERTY = 'stockConfiguration.selectedDepartmentId'

export function getStoredSelectedDepartmentId (user) {
  const userDepartmentsIds = user.employee && user.employee.allDepartmentIds || []

  const selectedDepartmentIdValue = localStorage.getItem(SELECTED_DEPARTMENT_ID_PROPERTY)
  if (selectedDepartmentIdValue && !isNaN(selectedDepartmentIdValue)) {
    const selectedDepartmentId = Number(selectedDepartmentIdValue)

    const hasEditAccess = user.hasOperation('stockAccessoryControl')
    const hasAllDepartmentsEditAccess = user.hasOperation('stockAccessoryControl') && user.hasRole('admin')
    if (hasAllDepartmentsEditAccess || hasEditAccess && userDepartmentsIds.includes(selectedDepartmentId)) {
      return selectedDepartmentId
    }
  }
  return null
}

export function setStoredSelectedDepartmentId (departmentId) {
  if (departmentId != null) {
    localStorage.setItem(SELECTED_DEPARTMENT_ID_PROPERTY, departmentId)
  } else {
    localStorage.removeItem(SELECTED_DEPARTMENT_ID_PROPERTY)
  }
}

export default {
  name: 'StockConfigurationDepartmentSelector',
  components: {
    ItemsSearchField
  },
  props: {
    label: {
      type: String,
      default: 'Отдел'
    },
    config: {
      type: Object,
      required: true
    }
  },
  data: function () {
    const vm = this

    return {
      selectedDepartment: null,
      fieldConfig: createFieldConfig(new Store({
        itemsFn: function () {
          return vm.config.departments
        },
        fullReadable: true,
        cached: false,
        searchable: true,
        searchColumns: ['name']
      }))

      // loading: false,
      // departmentId: null,
      // departments: [],
      // hasChanges: false
    }
  },
  computed: {
    hasEditAccess: function () {
      return this.$d_hasOperation('stockAccessoryControl')
    },
    hasAllDepartmentsEditAccess: function () {
      const user = this.$store.getters.getUser
      return user.hasOperation('stockAccessoryControl') && user.hasRole('admin')
    },
    departmentReadonly: function () {
      if (this.config.readonly) {
        return true
      }
      if (this.config.hasChanges) {
        return true
      }
      if (!this.config.departments || this.config.departments.length <= 1) {
        return true
      }
      return !this.hasAllDepartmentsEditAccess // user.employee && user.employee.allDepartmentIds && user.employee.departments.length === 1
    }
  },
  watch: {
    selectedDepartment: function (department) {
      this.config.department = department || null
      this.config.departmentId = department ? department.id : null

      setStoredSelectedDepartmentId(this.config.departmentId)
    }
  },
  created: function () {
    this.loadDepartments()
  },
  methods: {
    loadDepartments: function () {
      this.config.loading = true
      axiosGet({
        url: '/service/obj/search?nameField=name&type=department&limit=1000&sort=name&dir=ASC',
        onSuccess: (response) => {
          const user = this.$store.getters.getUser
          const userDepartmentsIds = user.employee && user.employee.allDepartmentIds || []

          const departments = response.data.result.filter(item => item.name !== '')
          for (const department of departments) {
            if (this.hasAllDepartmentsEditAccess) {
              department.editAccess = true
            } else if (this.hasEditAccess) {
              department.editAccess = userDepartmentsIds.includes(department.id)
            } else {
              department.editAccess = false
            }
          }

          const defaultDepartmentId = this.config.defaultDepartmentId || null
          let defaultDepartment = null
          if (defaultDepartmentId) {
            defaultDepartment = departments.find(item => item.id == defaultDepartmentId)
            if (defaultDepartment == null) {
              throw new Error('Ошибка определения отдела')
            }
          }
          if (!defaultDepartment) {
            const selectedDepartmentId = getStoredSelectedDepartmentId(user)
            const selectedDepartment = departments.find(item => item.id === selectedDepartmentId) || null
            // if (selectedDepartment && !selectedDepartment.editAccess) {
            //   selectedDepartment = null
            // }

            if (selectedDepartment) {
              defaultDepartment = selectedDepartment
            } else {
              let userDefaultDepartment = null
              if (!userDepartmentsIds.length) {
                const userDefaultDepartmentKey = '6a65c0d0-e15c-11e6-9d4b-00155d02fa01' // СО по умолчанию
                userDefaultDepartment = departments.find(item => item.key == userDefaultDepartmentKey) || null
              } else {
                const userDefaultDepartmentId = userDepartmentsIds[0]
                userDefaultDepartment = departments.find(item => item.id === userDefaultDepartmentId) || null
              }
              if (!userDefaultDepartment && departments.length) {
                userDefaultDepartment = departments[0]
              }
              defaultDepartment = userDefaultDepartment
            }
          }

          this.selectedDepartment = defaultDepartment
          this.config.departments = departments
        },
        onFailure: 'Ошибка загрузки списка отделов'
      })
        .finally(() => {
          this.config.loading = false
        })
    }
  }
}

